export default function getClassList(classList) {
  return Object.keys(classList).reduce((prev, curr) => {
    if (classList[curr]) {
      return `${prev} ${curr}`;
    }

    return prev;
  }, "");
}
